export function ProjectSummary({
  title,
  description,
  client,
  location,
  date,
  duration,
  area,
}) {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm">
      
      {/* Header */}
      <div className="mb-6">
        <h3 className="text-2xl font-semibold text-gray-600">
          {title}
        </h3>
        <p className="mt-2 text-gray-600 text-lg font-light leading-relaxed">
          {description}
        </p>
      </div>

      {/* Divider */}
      <div className="h-px bg-gray-100 mb-6" />

      {/* Info Grid */}
      <div className="grid grid-cols-2 gap-y-4 gap-x-6 text-sm">
        <Info label="Client" value={client} />
        <Info label="Location" value={location} />
        <Info label="Completion" value={date} />
        <Info label="Duration" value={duration} />
        <Info label="Area" value={area} />
        <Info label="Budget" value={'Confidential'} />
      </div>
    </div>
  )
}


function Info({ label, value }) {
  return (
    <div>
      <p className="text-gray-500 text-xs uppercase tracking-wide">
        {label}
      </p>
      <p className="font-medium text-gray-800">
        {value}
      </p>
    </div>
  )
}

